<script setup lang="ts">
import TagBadge from "@/components/TagBadge.vue"

defineProps<{
  tags: { id: string; name: string; color_class: string }[]
}>()
</script>

<template>
  <div v-if="tags.length" class="flex flex-wrap items-center gap-2">
    <TagBadge v-for="tag in tags" :key="tag.id" :tag="tag" />
  </div>
</template>
